import CardHoc from "../UI/CardHoc";
import { useNavigate } from "react-router-dom";

const BlogCard = (props) => {
  const navigate = useNavigate();
  const handleChange = async (e) => {
    navigate(`/blogs/${props.card.slug}`, {
      state: { blogId: props.card._id, scroll: true },
    });
  };
  return (
    <CardHoc parentClassName="flex-1" className="bg-white-900 relative hover:cursor-pointer">
      <div onClick={props.card.status ? handleChange : undefined}>
        <figure className="min-w-[280px]">
          <div className="h-48 bg-gray-500 rounded-t-lg">
            <img
              src={props.card?.imageUrl}
              alt={props.card?.heading}
              className="w-full h-full object-cover rounded-t-lg"
              draggable={false}
              loading="lazy"
            />
          </div>
          <figcaption className="p-4 rounded-b-lg bg-white-900 relative min-h-[175px]">
            <div className="flex gap-3 items-center">
              <h4 className="absolute -top-5 right-5 text-sm my-auto bg-primary rounded-md text-white-900 px-6 py-2">
                {props.card?.category}
              </h4>
              <p className="text-lg font-semibold">
                {props.card?.heading.length > 50
                  ? props.card?.heading.slice(0, 50) + " ..."
                  : props.card?.heading}
              </p>
            </div>
            {props.card?.description.length > 100 ? (
              <p className="text-md py-2">{props.card?.description.slice(0, 100)} ...</p>
            ) : (
              <p className="font-semibold text-lg py-2">{props.card?.description}</p>
            )}
          </figcaption>
        </figure>
      </div>
    </CardHoc>
  );
};

export default BlogCard;
